import { render, staticRenderFns } from "./dialog-createpassword.vue?vue&type=template&id=6f9deaa8&"
import script from "./dialog-createpassword.vue?vue&type=script&lang=js&"
export * from "./dialog-createpassword.vue?vue&type=script&lang=js&"
import style0 from "./dialog-createpassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports